/**
 * Soft vendor card used on the agent and homeowner vendor lists.
 * 1rem corners and a light lift, like the dashboard cards. No outline.
 */
export function vendorSoftShadow(isDark) {
  return isDark
    ? '0 8px 24px rgba(0, 0, 0, 0.35)'
    : '0 1px 2px rgba(15, 23, 42, 0.06), 0 10px 24px rgba(15, 23, 42, 0.08)';
}

export function vendorSoftCardStyle(colors, isDark) {
  const palette = colors || {};
  const dark = typeof isDark === 'boolean' ? isDark : palette.background === '#1a1a1a';
  return {
    background: palette.surface || '#ffffff',
    color: palette.text || 'inherit',
    border: 'none',
    borderRadius: '1rem',
    padding: '1rem 1.1rem',
    minWidth: 0,
    boxSizing: 'border-box',
    width: '100%',
    boxShadow: vendorSoftShadow(dark),
  };
}
